export const plantKeyTitleMap = [
  { key: 'metrc_plant_id', title: 'Metrc' },
  { key: 'batch_name', title: 'Batch Name' },
  { key: 'strain_name', title: 'Strain Name' },
  { key: 'metrc_tag_number', title: 'Metric Tag I.D' },
  { key: 'plant_phase', title: 'Growth Phase' },
  { key: 'wet_weight', title: 'Wet Weight' },
  { key: 'dry_weight', title: 'Dry Weight' },
  { key: 'frtl', title: 'FRTL' },
];

export const bucketsKeyTitleMap = [
  { key: 'serial_number', title: 'S.No.' },
  { key: 'name', title: 'Bucket Name' },
  { key: 'bucket_categories', title: 'Bucket Categories' },
  { key: 'item', title: 'Item' },
  { key: 'routine_type', title: 'Routine Type' },
  { key: 'frtl', title: 'FRTL' },
  { key: 'max_weight', title: 'Max Weight' },
  { key: 'weight', title: 'Weight' },
  { key: 'bucket_unit_of_measurement', title: 'U.O.M' },
  { key: 'harvests', title: 'Harvests' },
  { key: 'bucket_note', title: 'Bucket Note' },
  { key: 'actions', title: 'Actions' },
];

export const harvestsKeyTitleMap = [
  { key: 'serial_number', title: 'S.No.' },
  { key: 'harvest_name', title: 'Harvest Name' },
  // { key: 'metrc_harvest_id', title: 'METRC Harvest ID' },
  { key: 'harvest_date', title: 'Harvest Date' },
  { key: 'patient_license_number', title: 'Patient License' },
  { key: 'room_table', title: 'Room Table' },
  { key: 'frtl', title: 'FRTL' },
  { key: 'cropplanstrain', title: 'Strain' },
  // { key: 'is_finished', title: 'Status' },
  // { key: 'actions', title: 'Actions' },
];

export const packagesKeyTitleMap = [
  { key: 'serial_number', title: 'S.No.' },
  { key: 'metrc_package_id', title: 'Metrc' },
  { key: 'metrc_package_tag_number', title: 'Metrc Package Tag' },
  { key: 'frtl', title: 'FRTL' },
  { key: 'patient_license_number', title: 'Patient License' },
  { key: 'package_date', title: 'Package Date' },
  { key: 'original_package_weight', title: 'Original Package Weight' },
  { key: 'current_package_weight', title: 'Current Package Weight' },
  { key: 'item', title: 'Item' },
  { key: 'package_note', title: 'Note' },
  { key: 'metrc_unit_of_measurement', title: 'Unit of Measurement' },
  { key: 'harvests', title: 'Harvests' },
  { key: 'current_package_status', title: 'Status' },
  // { key: 'buckets', title: 'Buckets' },
  { key: 'subpackages_count', title: 'Sub Packages' },
  { key: 'actions', title: 'Actions' },
];

export const subPackagesKeyTitleMap = [
  { key: 'serial_number', title: 'S.No.' },
  { key: 'metrc_sub_package_id', title: 'Metrc' },
  { key: 'metrc_sub_package_tag_number', title: 'Sub Package Tag' },
  { key: 'frtl', title: 'FRTL' },
  // { key: 'patient_license_number', title: 'Patient License' },
  { key: 'sub_package_date', title: 'Sub Package Date' },
  { key: 'original_sub_package_weight', title: 'Original Weight' },
  { key: 'current_sub_package_weight', title: 'Current Weight' },
  { key: 'item', title: 'Item' },
  { key: 'sub_package_note', title: 'Note' },
  // { key: 'sub_package_type', title: 'Type' },
  { key: 'current_sub_package_status', title: 'Status' },
  { key: 'is_finished', title: 'Finished' },
  { key: 'archived_date', title: 'Archived Date' },
  { key: 'metrc_unit_of_measurement', title: 'Unit of Measurement' },
  { key: 'lab_sample_status', title: 'Lab Sample Status' },
  // { key: 'source_packages', title: 'Source Packages' },
  { key: 'lab_samples', title: 'Lab Samples' },
  { key: 'actions', title: 'Actions' },
];
